import throttle from "lodash.throttle";
import { toast } from "react-toastify";

const throttleHandler = throttle((content) => toast.warning(content), 4000);

export default throttleHandler;
